
import axios from "axios";

// API key constant
const API_KEY =
  "uEbwWdT5hhgikMjeSfOf5UwxnK9fPZRMveP5t3lFEyuR7rlKlixSs53wlrU9Vj9zsbnVCrlkrbCzcIap7hmjgjcGFPXcFNzELRb0dG3LrL2TWGkuKJH88QrCtLtsg0fw";

// Create axios instance with common headers
const api = axios.create({
  headers: {
    "x-api-key": API_KEY,
    "Content-Type": "application/json",
    Accept: "application/json",
    "Api-Version": "v1",
  },
});

export const updateUserInfo = async (userData, token) => {
  try {
    const response = await api.post(
      "https://app.foodiary.app/api/user/address/update",
      userData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "x-api-key":
            "uEbwWdT5hhgikMjeSfOf5UwxnK9fPZRMveP5t3lFEyuR7rlKlixSs53wlrU9Vj9zsbnVCrlkrbCzcIap7hmjgjcGFPXcFNzELRb0dG3LrL2TWGkuKJH88QrCtLtsg0fw",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("User info creation error:", error);
    throw error;
  }
};